import { render, staticRenderFns } from "./esgStructuredDataReportPage.vue?vue&type=template&id=f26faa78&scoped=true"
import script from "./esgStructuredDataReportPage.vue?vue&type=script&lang=js"
export * from "./esgStructuredDataReportPage.vue?vue&type=script&lang=js"
import style0 from "./esgStructuredDataReportPage.vue?vue&type=style&index=0&id=f26faa78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26faa78",
  null
  
)

export default component.exports